/* ESTASY — Cart drawer & AJAX cart logic using Shopify Cart API. */
(function () {
  'use strict';

  const moneyFormat = window.Estasy && window.Estasy.moneyFormat ? window.Estasy.moneyFormat : '€{{amount_with_comma_separator}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^\d-]/g, '');
    cents = parseInt(cents, 10) || 0;
    function fmt(precision, thousands, decimal) {
      const s = (Math.abs(cents) / 100).toFixed(precision);
      const parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const out = decimal && parts[1] ? parts.join(decimal) : parts[0];
      return (cents < 0 ? '-' : '') + out;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', '');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        default: return fmt(2, ',', '.');
      }
    });
  }

  function setBusy(busy) {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  async function refreshCart() {
    setBusy(true);
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const next = html.querySelector('[data-cart-contents]');
      const current = document.querySelector('[data-cart-contents]');
      if (next && current) current.innerHTML = next.innerHTML;
      const cart = await (await fetch('/cart.js')).json();
      updateCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {
      console.error('Cart refresh failed', e);
    } finally {
      setBusy(false);
    }
  }
  window.EstasyRefreshCart = refreshCart;

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function addToCart(form, openDrawer) {
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(serialize(form))
      });
      if (!res.ok) {
        const err = await res.json();
        flash(err.description || 'Articolo non disponibile', true);
        return;
      }
      await refreshCart();
      if (openDrawer && window.EstasyDrawers) window.EstasyDrawers.open('cart-drawer');
    } catch (e) {
      flash('Si è verificato un errore. Riprova.', true);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    }
  }

  function serialize(form) {
    const data = new FormData(form);
    const obj = { items: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10) }] };
    // capture line item properties
    const props = {};
    data.forEach((v, k) => {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    });
    if (Object.keys(props).length) obj.items[0].properties = props;
    return obj;
  }

  async function changeLine(key, quantity) {
    setBusy(true);
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      await refreshCart();
    } finally { setBusy(false); }
  }

  function flash(msg, isError) {
    let el = document.querySelector('[data-cart-flash]');
    if (!el) return alert(msg);
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    setTimeout(() => { el.hidden = true; }, 4000);
  }

  /* ---------- Event wiring ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form], form.product-form-ajax');
    if (!form) return;
    e.preventDefault();
    addToCart(form, true);
  });

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-cart-remove'), 0); return; }
  });

  document.addEventListener('change', (e) => {
    const qty = e.target.closest('[data-cart-qty]');
    if (qty) changeLine(qty.getAttribute('data-cart-qty'), parseInt(qty.value, 10));
  });

  window.EstasyFormatMoney = formatMoney;
})();
